export default __webpack_public_path__ + "static/media/successful.37151478.gif";